import { IHUBSERVICE_TOKEN } from '../../common/src/signalR/signalRServices';
import { InaxPlcService } from './plc';


export const PLC_HUBSERVICEPROVIDER_ENTRY = { provide: IHUBSERVICE_TOKEN, useClass: InaxPlcService, multi: true };